/**
 * Catalyst's Link, wired to react-router (the console's router).
 *
 * Catalyst ships this as a bare <a> with a TODO to bind it to your
 * framework's link component. Every Catalyst component that navigates
 * (Sidebar, Navbar, Dropdown, Pagination, Table rows) routes through
 * here, so this one swap gives the whole kit client-side navigation.
 *
 * External and non-path hrefs (http…, mailto:, tel:, #anchor) stay a
 * plain <a> — react-router's Link would try to route them internally.
 */

import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { Link as RouterLink } from 'react-router'

const isInternal = (href: string) => href.startsWith('/')

export const Link = forwardRef(function Link(
  props: { href: string } & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  const { href, ...rest } = props
  return (
    <Headless.DataInteractive>
      {isInternal(href) ? (
        <RouterLink to={href} {...rest} ref={ref} />
      ) : (
        <a href={href} {...rest} ref={ref} />
      )}
    </Headless.DataInteractive>
  )
})
